import { useEffect } from 'react';
import { DeleteItemsModal } from 'ui/indexPages/modals/DeleteItemsModal';
import { useDeleteListFolderModalState } from './hooks/useDeleteListFolderModalState';
import { useSelectionContext } from '../../contexts';

export const DeleteListContentsAndFoldersModal = () => {
  const { clearAll } = useSelectionContext();
  const { folders, content, onClose, onDelete, displayTextForContentItems } =
    useDeleteListFolderModalState();

  useEffect(() => {
    return () => {
      // when an item gets set through the actions, we need to clear it on the way out
      clearAll();
    };
  }, []);

  return (
    <DeleteItemsModal
      onClose={onClose}
      onConfirm={onDelete}
      content={content}
      folders={folders}
      displayTextForContentItems={displayTextForContentItems}
    />
  );
};
